import * as Sentry from '@sentry/browser';

export const initSentry = () => {
  try {
    doInitSentry();
  } catch (e) {
    // what else am I supposed to do here
    console.error(e);
  }
};

const doInitSentry = () => {
  Sentry.init({
    dsn: window.__SENTRY_DSN__,
    release: window.__APP_VERSION__,
    environment: window.__ENV__,
    integrations: [
      {
        name: 'RemoveTrash',
        setupOnce: (addGlobalEventProcessor) => {
          addGlobalEventProcessor((event) => {
            const value = event.exception?.values?.[0];
            if (value && value.type === 'UnhandledRejection' && !value.stacktrace) {
              return null;
            }
            return event;
          });
        },
      },
      new Sentry.Integrations.InboundFilters({
        ignoreErrors: [
          'conductExperiment?key=specs.fedinfra.Glassbox',
          'ResizeObserver loop limit exceeded',
          'ResizeObserver loop completed with undelivered notifications.',
          'logMutedMessage',
          'Permission denied to access property "unlock"',
          'Could not establish connection. Receiving end does not exist.',
          'Non-Error promise rejection captured with keys: currentTarget, detail, isTrusted, target',
        ],
        denyUrls: [
          /^(chrome|moz)-extension:\/\//,
          /safari-(web-)?extension/,
          /^webpack-internal:\/\//,
          /^\/\/hidden\//,
          /^<anonymous>/,
        ],
      }),
    ],
  });
  Sentry.configureScope((scope) => {
    const ud = window.__INITIAL_STATE__.userData;
    const userId = ud.isLoggedIn ? ud.profile.id : undefined;
    scope.setUser({ id: userId });
    scope.setExtra('editorSessionId', window.__INITIAL_STATE__.template.editorSessionId);
    scope.setExtra('visitorId', window.__VISITOR_ID__);
  });
};
